import React, { Component } from "react";
import p5 from "p5";
import SpaceMono from "../assets/fonts/SpaceMono-Regular.ttf";


export default class App extends Component {
    //React ref for div reference we pass into p5
    sketchRef = React.createRef();


    //P5 instance mode
    initSketch = (p) => {
        let canvas;
        // let pg1;
        // let p1;

        let w = window.innerWidth;
        let h = window.innerHeight;

        let rw = w * 0.65;

       
        let font;

        p.preload = () => {
            font = p.loadFont(SpaceMono, font);
        };

        p.setup = () => {
            //store width and height
            //setup canvas and init values here
            canvas = p.createCanvas(rw, h);

            //normal canvas
            

        };

        p.draw = () => {

           

            //show the results
           
        };

        p.windowResized = () => {
            w = window.innerWidth;
            h = window.innerHeight;
            rw = w * 0.65;
            p.resizeCanvas(rw, h);
        };

    };

    componentDidMount() {
        //Create p5 canvas once component mounts
        this.p5Canvas = new p5(this.initSketch, this.sketchRef.current);
    }

    componentWillUnmount() {
        this.p5Canvas.remove();
        window.removeEventListener('resize', this.windowResized);
    }

    render() {
        //this div will contain the sketch canvas
        return <div className="mySketch" ref={this.sketchRef} />;
    }
}

